<script>
export default {
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    projectOptions: {
      type: Array,
      default: () => ([]),
    },
    workerOptions: {
      type: Array,
      default: () => ([]),
    },
    canReadTask: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const { values } = this;
    const worker = (values.worker || {}).id || '';
    const project = (values.project || {}).id || '';

    return {
      worker,
      project,
      date: values.date ? values.date.substr(0, 10) : '',
      hours: values.hours || '',
      task: values.task || '',
      taskNumber: values.taskNumber,
    };
  },
  methods: {
    emitChange () {
      const { worker, project, date, hours, task, taskNumber } = this;

      this.$emit('change', { worker, project, date, hours, task, taskNumber });
    },

    handleWorkerInput (value) {
      this.worker = value;
      this.emitChange();
    },
    handleProjectInput (value) {
      this.project = value;
      this.emitChange();
    },
    handleDateInput (value) {
      this.date = value;
      this.emitChange();
    },
    handleHoursInput (value) {
      this.hours = value;
      this.emitChange();
    },
    handleTaskInput (value) {
      this.task = value;
      this.emitChange();
    },
    handleTaskNumberInput (value) {
      this.taskNumber = value;
      this.emitChange();
    },
  },
  render () {
    const { readonly, disabled } = this;

    return (
      <div>
        <div class="form-field">
          <div class="form-field__label">
            Дата
          </div>
          {!readonly
            ? (
              <u-datepicker
                value={this.date}
                required
                disabled={disabled}
                closeOnSelect
                placeholder="гггг-мм-дд"
                onInput={this.handleDateInput}
              />
            )
            : (
              <u-input
                static
                value={this.date}
              />
            )}
        </div>

        <div class="form-field">
          <div class="form-field__label">
            Сотрудник
          </div>
          {(!readonly && this.workerOptions.length > 0)
            ? (
              <u-select
                value={this.worker}
                required
                disabled={disabled}
                fullwidth
                options={this.workerOptions}
                onInput={this.handleWorkerInput}
              />
            )
            : (
              <u-input
                static
                fullwidth
                value={this.values.worker.name}
              />
            )}
        </div>

        <div class="form-field">
          <div class="form-field__label">
            Проект
          </div>
          {(!readonly && this.projectOptions.length > 0)
            ? (
              <u-select
                value={this.project}
                required
                disabled={disabled}
                fullwidth
                options={this.projectOptions}
                onInput={this.handleProjectInput}
              />
            )
            : (
              <u-input
                static
                fullwidth
                value={this.values.project.name}
              />
            )}
        </div>

        {this.canReadTask && (
          <div class="form-field">
            <div class="form-field__label">
              <label for="taskInput">
                Описание задачи
              </label>
            </div>
            <u-input
              id="taskInput"
              name="task"
              required
              static={readonly}
              disabled={disabled}
              fullwidth
              value={this.task}
              onInput={this.handleTaskInput}
            />
          </div>
        )}

        <div class="form-field">
          <div class="form-field__label">
            <label for="taskNumberInput">
              Номер задачи
            </label>
          </div>
          <u-input
            id="taskNumberInput"
            name="taskNumber"
            static={readonly}
            disabled={disabled}
            fullwidth
            value={this.taskNumber}
            onInput={this.handleTaskNumberInput}
          />
        </div>

        <div class="form-field">
          <div class="form-field__label">
            <label for="hopursInput">
              Трудозатраты
            </label>
          </div>
          <u-input
            id="hopursInput"
            name="hours"
            required
            static={readonly}
            disabled={disabled}
            type="number"
            value={this.hours}
            onInput={this.handleHoursInput}
          />
        </div>
      </div>
    );
  },
};
</script>
